import React from "react";

export const TrainsSection = props => {
  var trainsThatStop = props.trains.filter(function(train) {
    return train.isStopping;
  });

  return (
    <tbody>
      {trainsThatStop.map(schedule => (
        <tr className="timetable-row">
          <td className="timetable-departure">
            {schedule.departureTime.slice(0, 5)}
          </td>
          <td className="timetable-midstation">
            <div  dangerouslySetInnerHTML={{
                __html: schedule.stacjaKoncowa
              }}/>
              {/* <div>{schedule.stacjaKoncowa}</div> */}
            
            {schedule.stacjaPrzez !== "" ? <div className="timetable-row__delays midstation" dangerouslySetInnerHTML={{
                __html: "przez: " + schedule.stacjaPrzez
              }}/> : <div className="timetable-row__delays midstation"></div>}
            <div className="timetable-row__delays delay">
              {schedule.delay > 2
                ? "opóźniony: " + schedule.delay + " min."
                : ""}
            </div>
          </td>

          <td>{schedule.track}</td>
        </tr>
      ))}
    </tbody>
  );
};
